import { Layout, notification, Spin } from 'antd';
import CustomHeader from './header';
import { useDispatch, useSelector } from 'react-redux';
import {
  getSharedState,
} from '../../store/selectors/stateSelector';
import { useEffect } from 'react';
import { ApiEventType } from '../../models/event';
import { setEvent } from '../../store/reducers/sharedReducer';
const { Content } = Layout;

const Main = ({ children }: any) => {
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  const { loading, event } = useSelector(getSharedState);

  useEffect(() => {
    if (event !== null) {
      notification[event.type]({
        message:
          event.type === ApiEventType.Success
            ? 'Success'
            : 'Something went wrong',
        description: event.message,
      });
      dispatch<any>(setEvent(null));
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  return (
    <Layout style={{ height: '100vh', margin: 0, padding: 0 }}>
      {contextHolder}
      <CustomHeader />
      <Layout
        className='ant-layout-has-sider'
        style={{ padding: '48px 0 0 0', height: '100%' }}
      >
        {/* <Sidenav /> */}

        <Layout
          style={{
            padding: '0 24px 24px 24px',
            overflow: 'scroll',
          }}
        >
          <Content
            className='site-layout-background'
            style={{
              padding: '16px 0',
              margin: 0,
              minHeight: 280,
              background: '#f0f2f5',
              height: '100%',
            }}
          >
            <Spin spinning={loading}>{children}</Spin>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Main;
